module.exports = __webpack_public_path__ + "media/images/icons/icons_large/12_bird-8a5da219de1cf347fd73faaa81eed54b.png";